/**
 * row-mobile.js
 */

import React from 'react';
import { ListItem, IconButton, Collapse } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Icon from 'components/icon';


const useStyles = makeStyles(theme => ({
  li: {
    transition: '250ms ease-in-out',
    marginBottom: 0,
    backgroundColor: theme.palette.sys.surfaceContainer,
    borderBottom: `1px solid ${theme.palette.sys.outlineVariant}`,
    '&.expanded': {
      marginBottom: theme.spacing(2),
    }
  },
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    '& .MuiSvgIcon-root.expander': {
      transition: '250ms ease-in-out',
    },
    '&.expanded .MuiSvgIcon-root.expander': {
      transform: `rotateX(180deg)`
    }
  },
  content: {
    flex: 1,
    '& .action': {
      margin: `0 ${theme.spacing(1)}`
    }
  },
  collapsibleContainer: {
    marginTop: theme.spacing(2)
  }
}));


export default function RowMobile(props) {
  const {
    nameContent,
    expansionContent,
    menu,
    isExpanded: isExpandedProp,
  } = props;
  const classes = useStyles();
  const [isExpanded, setIsExpanded] = React.useState(false);

  React.useEffect(() => setIsExpanded(isExpandedProp), [isExpandedProp]);

  return (
    <ListItem className={`${classes.li} ${isExpanded ? 'expanded' : ''}`}>
      <div className={`${classes.container} ${isExpanded ? 'expanded' : ''}`}>
        <div className={`flex-hc ${classes.content}`}>
          {nameContent}

          <div style={{ flex: 1 }} />

          <div className='flex-hc action'>{menu}</div>
          {Boolean(expansionContent) && 
          <div className='flex-hc action'>
            <IconButton size='small' onClick={() => setIsExpanded(p => !p)}><Icon type='expander' /></IconButton>
          </div>}
        </div>

        {/* COLLAPSIBLE ROW */}
        {Boolean(expansionContent) &&
        <Collapse in={isExpanded}><div className={classes.collapsibleContainer}>{expansionContent}</div></Collapse>}
      </div>
    </ListItem>
  );
}